import React, { useEffect, useRef, useState } from "react";
import { NumericFormat } from "react-number-format";
import { useLocation } from 'react-router-dom';
import {
  Block,
  BlockBetween,
  BlockHead,
  BlockHeadContent,
  BlockTitle,
  Button,
  Icon,
} from "../../components/Component";
import DatePicker from "../../components/range-date-picker/RangeDatePicker";
import Table from "../../components/react-table/Table";
import { GET } from "../../helper/api";
import Content from "../../layout/content/Content";
import Head from "../../layout/head/Head";

import * as moment from "moment";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import ReactSelect from "react-select";
import ReactToPrint from "react-to-print";
import { getToken } from "../../helper/auth";
import { INVENTORY_FUEL_CATEGORY, renderPageStyle } from "../../utils/Utils";

const INVENTORY_FUEL_CATEGORY_OPTIONS = Object.keys(INVENTORY_FUEL_CATEGORY).map((c) => ({
  label: INVENTORY_FUEL_CATEGORY[c],
  value: c,
}));

const InventorySummary = () => {
  const printRef = useRef();
  const history = useHistory();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);

  const [data, setData] = useState([]);
  const [summary, setSummary] = useState({});
  const [loading, setLoading] = useState(false);
  const [timeNow, setTimeNow] = useState();
  const [smOption, setSmOption] = useState(false);
  const [rangeDate, setRangeDate] = useState({
    startDate: searchParams.get('startDate') ? moment(searchParams.get('startDate')).startOf('days').toDate() : moment().startOf("months").toDate(),
    endDate: searchParams.get('endDate') ? moment(searchParams.get('endDate')).endOf('days').toDate() : moment().endOf('days').toDate(),
  });

  const [filter, setFilter] = useState({
    category: searchParams.get('category') || 'OIL',
  });

  const [warehouseOptions, setWarehouseOptions] = useState([]);
  const onRangeChange = (dates) => {
    const [startDate, endDate] = dates;
    setRangeDate({
      startDate: startDate ? moment(startDate)?.startOf('days').toDate() : startDate,
      endDate: endDate ? moment(endDate)?.endOf('days').toDate() : endDate
    });
    if (startDate && endDate) {
      setTimeNow(moment().valueOf());
    }
  };

  const colTable = [
    {
      Header: "KHO",
      accessor: (item) => warehouseOptions.find(e => e.value === item.warehouseId)?.label,
    },
    {
      Header: "Số lượng tồn đầu kỳ",
      className: 'text-right',
      accessor: (item) => <NumericFormat
        displayType={"text"}
        value={item.firstQuantity || 0}
        thousandsGroupStyle="thousand"
        thousandSeparator=","
        decimalScale={2}
      />,
    },
    {
      Header: "Thành tiền tồn đầu kỳ",
      className: 'text-right',
      accessor: (item) => <NumericFormat
        displayType={"text"}
        value={item.firstPrice || 0}
        thousandsGroupStyle="thousand"
        thousandSeparator=","
        decimalScale={2}
      />,
    },
    {
      Header: "Số lượng nhập trong kỳ",
      className: 'text-right',
      accessor: (item) => <NumericFormat
        displayType={"text"}
        value={item.inQuantity || 0}
        thousandsGroupStyle="thousand"
        thousandSeparator=","
        decimalScale={2}
      />,
    },
    {
      Header: "Thành tiền nhập trong kỳ",
      className: 'text-right',
      accessor: (item) => <NumericFormat
        displayType={"text"}
        value={item.inPrice || 0}
        thousandsGroupStyle="thousand"
        thousandSeparator=","
        decimalScale={2}
      />,
    },
    {
      Header: "Số lượng xuất trong kỳ",
      className: 'text-right',
      accessor: (item) => <NumericFormat
        displayType={"text"}
        value={item.outQuantity || 0}
        thousandsGroupStyle="thousand"
        thousandSeparator=","
        decimalScale={2}
      />,
    },
    {
      Header: "Thành tiền xuất trong kỳ",
      className: 'text-right',
      accessor: (item) => <NumericFormat
        displayType={"text"}
        value={item.outPrice || 0}
        thousandsGroupStyle="thousand"
        thousandSeparator=","
        decimalScale={2}
      />,
    },
    {
      Header: "Số lượng tồn cuối kỳ",
      className: 'text-right',
      accessor: (item) => <NumericFormat
        displayType={"text"}
        value={item.lastQuantity || 0}
        thousandsGroupStyle="thousand"
        thousandSeparator=","
        decimalScale={2}
      />,
    },
    {
      Header: "Thành tiền tồn cuối kỳ",
      className: 'text-right',
      accessor: (item) => <NumericFormat
        displayType={"text"}
        value={item.lastPrice || 0}
        thousandsGroupStyle="thousand"
        thousandSeparator=","
        decimalScale={2}
      />,
    },
  ];

  useEffect(() => {
    GET(`/warehouse`, {}, true).then(({ data: { rows } }) => {
      setWarehouseOptions(rows.map(e => ({
        label: e.name,
        value: e.id
      })));
    });
  }, []);

  // Changing state value when searching name
  useEffect(() => {
    const newParams = new URLSearchParams({
      ...rangeDate,
      category: filter.category
    });
    history.replace({
      pathname: location.pathname,
      search: newParams.toString(),
    })

    setLoading(true);
    let params = {
      startDate: moment(rangeDate.startDate).format("YYYY-MM-DD"),
      endDate: moment(rangeDate.endDate).format("YYYY-MM-DD"),
      category: filter.category

    };

    GET(`inventory/summary-statement-inventory-transaction-by-category`, params, true)
      .then(({ data }) => {

        const newData = []
        Object.entries(data?.rows).forEach(([warehouseId, warehouseData]) => {
          warehouseData?.[filter.category]?.forEach(item => {
            newData.push({
              ...item,
              warehouseId
            })
          })
        })

        setData(newData);
        setSummary(data.summary)
      })
      .finally(() => {
        setLoading(false);
      });
  }, [timeNow, filter]);

  const exportExcel = () => {
    const params = new URLSearchParams({
      startDate: moment(rangeDate.startDate).format("YYYY-MM-DD"),
      endDate: moment(rangeDate.endDate).format("YYYY-MM-DD"),
      category: filter.category,
      token: getToken(),
    })
    const url = `${process.env.REACT_APP_API_URL}/api/v1/inventory/summary-statement-inventory-transaction-by-category-excel?${params.toString()}`;
    window.open(url, '_blank')
  };

  return (
    <React.Fragment>
      <Head title="Quản lý tổng kho"></Head>
      <Content>
        <BlockHead size="sm">
          <BlockBetween>
            <BlockHeadContent>
              <BlockTitle page>Tổng hợp nhập xuất nhiên liệu</BlockTitle>
            </BlockHeadContent>
            <BlockHeadContent>
              <div className="toggle-wrap nk-block-tools-toggle">
                <a
                  href="#more"
                  className="btn btn-icon btn-trigger toggle-expand mr-n1"
                  onClick={(ev) => {
                    ev.preventDefault();
                    setSmOption(!smOption);
                  }}
                >
                  <Icon name="more-v"></Icon>
                </a>
                <div
                  className="toggle-expand-content"
                  style={{ display: smOption ? "block" : "none" }}
                >
                  <ul className="d-lg-flex g-3 pt-1 pb-1 custom-filter-header justify-content-end">
                    <li>
                      <div className="form-control-wrap">
                        <DatePicker
                          selected={rangeDate.startDate}
                          startDate={rangeDate.startDate}
                          onChange={onRangeChange}
                          endDate={rangeDate.endDate}
                          maxDate={new Date()}
                          selectsRange
                          className="form-control date-picker"
                        />
                      </div>
                    </li>
                    <li>
                      <div
                        className="form-control-wrap"
                        style={{ width: "200px" }}
                      >
                        <ReactSelect
                          placeholder="Tìm kiếm loại"
                          classNamePrefix="form-control"
                          options={INVENTORY_FUEL_CATEGORY_OPTIONS}
                          value={INVENTORY_FUEL_CATEGORY_OPTIONS.find(
                            (c) => c.value === filter.category
                          )}
                          onChange={(val) =>
                            setFilter({
                              ...filter,
                              category: (val && val.value) || "",
                            })
                          }
                        />
                      </div>
                    </li>
                    <li>
                      <div>
                        <ReactToPrint
                          trigger={() => <Button color="secondary">In</Button>}
                          content={() => printRef.current}
                          pageStyle={``}
                        />
                        <Button
                          className={`ml-3`}
                          color="secondary"
                          onClick={exportExcel}
                        >
                          <span>Xuất excel</span>
                        </Button>

                      </div>

                    </li>
                  </ul>
                </div>
              </div>
            </BlockHeadContent>
          </BlockBetween>
        </BlockHead>

        <Block>
          <div className="card card-bordered card-preview">
            <div className="card-inner">
              <div
                id="DataTables_Table_1_wrapper"
                className="dataTables_wrapper dt-bootstrap4 no-footer"
              >
                <div className="row justify-between g-2">
                  <div className="col-8 col-sm-6 text-start"></div>
                  <div className="col-5 col-sm-6 text-end">
                    <div className="datatable-filter">
                      <div className="d-flex justify-content-end g-2">
                        <div
                          className="dataTables_length"
                          id="DataTables_Table_1_length"
                        ></div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="my-3" ref={printRef}>
                  <h5 className="text-center">Tổng hợp nhập xuất {INVENTORY_FUEL_CATEGORY[filter.category]?.toLowerCase()} từ ngày {moment(rangeDate.startDate).format('DD-MM-YYYY')} đến {moment(rangeDate.endDate).format('DD-MM-YYYY')}</h5>
                  <style>{renderPageStyle()}</style>
                  <Table
                    loading={loading}
                    columns={colTable}
                    data={data}
                    notShowPagi={true}
                    headerRow={(
                      <tr className="nk-tb-item odd font-weight-bold">
                        <td className="nk-tb-col">
                          <span> Tổng cộng </span>
                        </td>
                        <td className="nk-tb-col text-right">
                          <span>
                            <NumericFormat
                              value={summary?.firstQuantity || 0}
                              displayType={'text'}
                              decimalScale={2}
                              thousandSeparator={','}
                              thousandsGroupStyle="thousand"
                            />
                          </span>
                        </td>
                        <td className="nk-tb-col text-right">
                          <span>
                            <NumericFormat
                              value={summary?.firstPrice || 0}
                              displayType={'text'}
                              decimalScale={2}
                              thousandSeparator={','}
                              thousandsGroupStyle="thousand"
                            />
                          </span>
                        </td>
                        <td className="nk-tb-col text-right">
                          <span>
                            <NumericFormat
                              value={summary?.inQuantity || 0}
                              displayType={'text'}
                              decimalScale={2}
                              thousandSeparator={','}
                              thousandsGroupStyle="thousand"
                            />
                          </span>
                        </td>
                        <td className="nk-tb-col text-right">
                          <span>
                            <NumericFormat
                              value={summary?.inPrice || 0}
                              displayType={'text'}
                              decimalScale={2}
                              thousandSeparator={','}
                              thousandsGroupStyle="thousand"
                            />
                          </span>
                        </td>
                        <td className="nk-tb-col text-right">
                          <span>
                            <NumericFormat
                              value={summary?.outQuantity || 0}
                              displayType={'text'}
                              decimalScale={2}
                              thousandSeparator={','}
                              thousandsGroupStyle="thousand"
                            />
                          </span>
                        </td>
                        <td className="nk-tb-col text-right">
                          <span>
                            <NumericFormat
                              value={summary?.outPrice || 0}
                              displayType={'text'}
                              decimalScale={2}
                              thousandSeparator={','}
                              thousandsGroupStyle="thousand"
                            />
                          </span>
                        </td>
                        <td className="nk-tb-col text-right">
                          <span>
                            <NumericFormat
                              value={summary?.lastQuantity || 0}
                              displayType={'text'}
                              decimalScale={2}
                              thousandSeparator={','}
                              thousandsGroupStyle="thousand"
                            />
                          </span>
                        </td>
                        <td className="nk-tb-col text-right">
                          <span>
                            <NumericFormat
                              value={summary?.lastPrice || 0}
                              displayType={'text'}
                              decimalScale={2}
                              thousandSeparator={','}
                              thousandsGroupStyle="thousand"
                            />
                          </span>
                        </td>
                      </tr>
                    )}
                  ></Table>
                </div>
              </div>
            </div>
          </div>
        </Block>
      </Content>
    </React.Fragment>
  );
};

export default InventorySummary;
